// extracted by mini-css-extract-plugin
module.exports = {"styledRow":"styles_styledRow__ZO7rM","styledRow__header":"styles_styledRow__header__3PkIo","styledRow__footer":"styles_styledRow__footer__32k7r"};